import { IMutationProps } from '../../../interfaces/ui';
import { useMutationWithResultNotification } from '../useMutationWithResultNotification';
import { updateCaseConversationSchedule } from '../../conversationSchedules';
import {
  displayErrorArrayNotificationsWithoutTranslations,
  displayErrorNotification,
  displaySuccessNotification,
} from '../../../modules/Notifications';
import { IErrorDefinition } from '../../../interfaces/response';
import { IUpdateCaseConversationSchedule } from '../../../interfaces/conversationSchedules';

type useUpdateCaseConversationScheduleParams = {
  organizationId: string;
  caseId: string;
};

export type useUpdateCaseConversationScheduleData = {
  id: string;
  data: IUpdateCaseConversationSchedule;
};

const useUpdateCaseConversationSchedule = (
  params: useUpdateCaseConversationScheduleParams,
  options: IMutationProps
) => {
  return useMutationWithResultNotification({
    asyncApiFunction: async (data: useUpdateCaseConversationScheduleData) => {
      await updateCaseConversationSchedule(
        params.organizationId,
        params.caseId,
        data.id,
        data.data
      );
    },
    onSuccess: () => {
      displaySuccessNotification(
        'Api.Mutations.ConversationSchedules.UpdateCaseConversationSchedule.success'
      );

      if (options.successFb) options.successFb();
    },
    onErrorArray: (errors: IErrorDefinition[]) => {
      displayErrorNotification(
        'Api.Mutations.ConversationSchedules.UpdateCaseConversationSchedule.failure'
      );

      displayErrorArrayNotificationsWithoutTranslations(errors);

      if (options.errorFb) options.errorFb();
    },
    resetOnResult: true,
  });
};

export default useUpdateCaseConversationSchedule;
